import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../styles/Legal.css';

export default function TermsOfUse() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="legal-container">
      <div className="legal-section">
        <h1>Terms of Use</h1>

        <section>
          <h2>Introduction</h2>
          <p>These Terms of Use ("Terms") govern your access to and use of the pen-testing and ethical hacking game (the "Game") provided by BreakMe.ai ("we," "us," or "our"). By accessing or using the Game, you agree to be bound by these Terms. If you disagree with any part of these Terms, you must immediately stop interacting with the Game, its website, or any related channels.</p>
        </section>

        <section>
          <h2>1. Eligibility</h2>
          <p>By using the Game, you confirm that you:</p>
          <ul>
            <li>Are at least 18 years old or of the age of majority in your jurisdiction.</li>
            <li>Are not located in a region subject to OFAC sanctions or other trade restrictions (see Privacy Policy for a list of prohibited countries).</li>
            <li>Are not using a VPN or similar tool to mask your IP address to bypass restrictions.</li>
            <li>Are not using the Game for unlawful purposes.</li>
          </ul>
        </section>

        <section>
          <h2>2. Gameplay Rules</h2>
          <ul>
            <li>All interactions within the Game must comply with its stated rules and ethical guidelines.</li>
            <li>Attempts to exploit or manipulate the Game outside the intended gameplay are strictly prohibited.</li>
            <li>Bounties are distributed automatically and are subject to verification of compliance with all rules.</li>
          </ul>
        </section>

        <section>
          <h2>3. Disclaimers</h2>
          <ul>
            <li>The Game is provided "as is" and "as available" without warranties of any kind, either express or implied.</li>
            <li>We do not guarantee the availability, accuracy, or fairness of the Game.</li>
            <li>Participation in the Game is at your own risk. We are not liable for losses, damages, or disputes arising from your use of the Game.</li>
          </ul>
        </section>

        <section>
          <h2>4. Limitation of Liability</h2>
          <p>To the fullest extent permitted by law:</p>
          <ul>
            <li>BreakMe.ai is not responsible for any direct, indirect, incidental, or consequential damages arising from your participation in the Game.</li>
            <li>By using the Game, you agree to indemnify and hold harmless BreakMe.ai, its creators, and affiliates from any claims, damages, or liabilities, including legal fees, resulting from your participation in the Game.</li>
          </ul>
        </section>

        <section>
          <h2>5. Dispute Resolution</h2>
          <ul>
            <li>Disputes will first be addressed informally. Contact us via our official Telegram channels to resolve any issues.</li>
            <li>If informal resolution is not possible, disputes will be resolved through binding arbitration in accordance with applicable arbitration rules.</li>
          </ul>
        </section>

        <section>
          <h2>6. Termination</h2>
          <p>We reserve the right to terminate or suspend your access to the Game at any time, without notice, for any reason.</p>
        </section>

        <section>
          <h2>7. Updates to These Terms</h2>
          <p>We may update these Terms periodically. Changes will take effect upon posting the updated Terms.</p>
        </section>

        <section>
          <p>If you have any questions about these Terms or the Privacy Policy, please contact us via our official Telegram channels.</p>
        </section>
      </div>
      
      <div className="legal-footer">
        <Link to="/" className="nes-btn is-primary">
          🎮 Return to Game
        </Link>
      </div>
    </div>
  );
} 